import LinkLanguage from "locales/LinkLanguage";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import { RootState } from "store";
import { useSelector } from "react-redux";
import "./Logo.scss";
import { logo_alt } from "utils/textConstants";
import { API_IMAGES_URL } from "config/constants";

const Logo = ({ type }: any) => {
  const [device, orientation] = useEffectDeviceAndOrientation();
  const theme = useSelector((state: RootState) => state.theme);
  const image =
    theme === "light"
      ? "assets/logo_dark_lightmode.png"
      : "assets/logo_light_darkmode.png";
  // const image = theme === "light" ? logoLightMode : logoDarkMode;
  return (
    <LinkLanguage
      className={`Header-Logo-${type}`}
      to="/"
      style={
        device === "mobile" || orientation === "vertical"
          ? { justifyContent: "center" }
          : { justifyContent: "left" }
      }
    >
      <img
        className="Logo-Link"
        alt={logo_alt}
        src={API_IMAGES_URL + image}
        // src={image}
      />
    </LinkLanguage>
  );
};
export default Logo;
